import { render, staticRenderFns } from "./AlertTop.vue?vue&type=template&id=9bb5e968&scoped=true&"
import script from "./AlertTop.vue?vue&type=script&lang=js&"
export * from "./AlertTop.vue?vue&type=script&lang=js&"
import style0 from "./AlertTop.vue?vue&type=style&index=0&id=9bb5e968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb5e968",
  null
  
)

export default component.exports